class ProductCustomGallery {
  constructor(container) {
    this.container = container;

    this.stage = container.querySelector('.product-custom-gallery__stage');
    this.mediaContainer = container.querySelector('.product-custom-gallery__media-container');
    this.track = container.querySelector('.product-custom-gallery__track');
    this.dotsContainer = container.querySelector('.product-custom-gallery__dots');
    this.prevButton = container.querySelector('.product-custom-gallery__arrow--prev');
    this.nextButton = container.querySelector('.product-custom-gallery__arrow--next');

    this.standardThumbnailsContainer = container.querySelector(
      '.product-custom-gallery__thumbnails--standard'
    );

    this.premiumThumbnailsContainer = container.querySelector(
      '.product-custom-gallery__thumbnails--premium'
    );

    // Standard is active initially
    this.thumbnailsContainer = this.standardThumbnailsContainer;

    this.thumbnails = [
      ...this.thumbnailsContainer.querySelectorAll(
        '.product-custom-gallery__thumbnail'
      )
    ];

    this.dotsContainer = container.querySelector('.product-custom-gallery__dots');

    this.data = JSON.parse(
      container.querySelector('.product-custom-gallery__data').textContent
    );

    this.gallerySets = {
      standard: this.data.groups.standard.map((group, index) => ({
        ...group,
        groupIndex: index
      })),
      premium: this.data.groups.premium.map((group, index) => ({
        ...group,
        groupIndex: index
      }))
    };

    this.gallerySets.standard.forEach(group => {
      group.originalMedia = [...group.media];
    });

    this.gallerySets.premium.forEach(group => {
      group.originalMedia = [...group.media];
    });

    this.galleryType = 'standard';

    this.gallery = {
      groups: this.gallerySets.standard,
      slides: []
    };

    this.dynamicGroupIndex = this.gallery.groups.findIndex(
      group => group.isDynamic
    );

    if (this.dynamicGroupIndex === -1) {
      this.dynamicGroupIndex = 0;
    }

    const standardDynamicIndex = this.gallerySets.standard.findIndex(
      group => group.isDynamic
    );

    const premiumDynamicIndex = this.gallerySets.premium.findIndex(
      group => group.isDynamic
    );

    // this.defaultDynamicMedia = {
    //   standard:
    //     standardDynamicIndex >= 0
    //       ? [...this.gallerySets.standard[standardDynamicIndex].media]
    //       : [],

    //   premium:
    //     premiumDynamicIndex >= 0
    //       ? [...this.gallerySets.premium[premiumDynamicIndex].media]
    //       : []
    // };

    this.currentIndex = 0;
    this.isAnimating = false;
    this.useInfiniteLoop = true;
    this.videoLoop = container.dataset.videoLoop === 'true';
    this.VIDEO_WARMUP_DELAY = 600;
    this.TRANSITION = 'transform .45s cubic-bezier(.22,.61,.36,1)';
    this.preloadedImages = new Set();

    this.swipe = {
        startX: 0,
        startY: 0
    };

    this.buildSlides();
    this.setCurrentIndex(0);
    this.bindEvents();
    this.bindVariantEvents();
    this.initSwipe();
    this.render();
  }

  get dynamicGroup() {
    return this.gallery.groups[this.dynamicGroupIndex];
  }

  refreshThumbnails() {

    this.thumbnailsContainer =
      this.galleryType === 'premium'
        ? this.premiumThumbnailsContainer
        : this.standardThumbnailsContainer;

    this.thumbnails = [
      ...this.thumbnailsContainer.querySelectorAll(
        '.product-custom-gallery__thumbnail'
      )
    ];

  }

  setGalleryType(type = 'standard') {

    if (this.galleryType === type) return;

    this.pauseAllVideos();

    this.galleryType = type;

    // Show/hide thumbnail containers
    this.standardThumbnailsContainer.classList.toggle(
      'hidden',
      type === 'premium'
    );

    this.premiumThumbnailsContainer.classList.toggle(
      'hidden',
      type === 'standard'
    );

    // Refresh active thumbnail references
    this.refreshThumbnails();

    // Switch gallery set
    this.gallery.groups = this.gallerySets[type];

    // Find the dynamic group in the new gallery
    this.dynamicGroupIndex = this.gallery.groups.findIndex(
      group => group.isDynamic
    );

    if (this.dynamicGroupIndex === -1) {
      this.dynamicGroupIndex = 0;
    }

    // this.defaultDynamicMedia = [
    //   ...this.gallery.groups[this.dynamicGroupIndex].media
    // ];

    this.preloadedImages.clear();

    this.buildSlides();

    this.setCurrentIndex(0);

    this.render();

  }

  buildSlides() {
    this.gallery.slides = [];

    this.gallery.groups.forEach((group) => {
      const groupSize = group.media.length;

      group.media.forEach((media, mediaIndex) => {
        this.gallery.slides.push({
          ...media,

          groupId: group.id,
          groupTitle: group.title,
          groupIndex: group.groupIndex,

          mediaIndex,
          groupSize
        });
      });
    });
  }  

  rebuildGallery() {
    this.buildSlides();

    if (this.currentIndex >= this.gallery.slides.length) {
      this.currentIndex = 0;
    }

    this.render();
  }

  handleInfiniteLoop() {

    if (!this.useInfiniteLoop || this.gallery.slides.length <= 1) {
      this.isAnimating = false;
      return;
    }

    if (this.trackIndex === this.gallery.slides.length + 1) {

      this.trackIndex = 1;
      this.updateTrackPosition(false);

    } else if (this.trackIndex === 0) {

      this.trackIndex = this.gallery.slides.length;
      this.updateTrackPosition(false);

    }

    this.updateActiveSlide();
    this.playCurrentVideo();

    this.track.offsetHeight;
    this.track.style.transition = this.TRANSITION;

    this.isAnimating = false;
  }

  bindEvents() {
    this.prevButton.addEventListener('click', () => this.previous());

    this.nextButton.addEventListener('click', () => this.next());

    [
      this.standardThumbnailsContainer,
      this.premiumThumbnailsContainer
    ].forEach(container => {

      container.addEventListener('click', (event) => {

        const thumb = event.target.closest(
          '.product-custom-gallery__thumbnail'
        );

        if (!thumb) return;

        this.goToGroup(Number(thumb.dataset.groupIndex));

      });

    });

    this.track.addEventListener(
      'transitionend',
      this.handleInfiniteLoop.bind(this)
    );
  }

  bindVariantEvents() {

    document.addEventListener('catchy:variant-change', (event) => {
      this.setVariant(event.detail.variant);
    });

    document.addEventListener('catchy:premium-change', (event) => {
      this.setGalleryType(
        event.detail.isPremium ? 'premium' : 'standard'
      );

      // Reapply the currently selected variant to the new gallery
      this.setVariant(event.detail.variant);
    });

  }

  removeDuplicateMedia(mediaList) {
    const seen = new Set();

    return mediaList.filter((media) => {
      if (seen.has(media.id)) {
        return false;
      }

      seen.add(media.id);
      return true;
    });
  }

  setVariant(variant) {

    this.pauseAllVideos();

    let media = [];

    if (variant) {
      media = this.data.variants[String(variant.id)] || [];
    }

    // Fallback to the default dynamic gallery for the active gallery type
    if (!media.length) {
      media = [...this.dynamicGroup.originalMedia];
    }

    media = this.removeDuplicateMedia(media);

    this.dynamicGroup.media = media;

    this.updateDynamicThumbnail(media);

    this.mediaContainer.classList.add('is-changing');

    const firstMedia = media[0];

    const finishUpdate = () => {

      this.preloadedImages.clear();

      this.rebuildGallery();

      // Always reset to the first slide of the dynamic gallery
      this.goToGroup(this.dynamicGroupIndex);

      this.render();

      requestAnimationFrame(() => {
        this.mediaContainer.classList.remove('is-changing');
      });

    };

    if (!firstMedia) {
      finishUpdate();
      return;
    }

    if (firstMedia.type === 'image') {

      const img = new Image();

      img.onload = finishUpdate;
      img.onerror = finishUpdate;
      img.src = firstMedia.url;

    } else if (firstMedia.type === 'video') {

      const source =
        firstMedia.sources?.find(s => s.format === 'mp4' && s.height >= 720) ||
        firstMedia.sources?.find(s => s.format === 'mp4') ||
        firstMedia.sources?.[0];

      if (!source) {
        finishUpdate();
        return;
      }

      const video = document.createElement('video');

      video.preload = 'metadata';
      video.src = source.url.startsWith('//')
        ? `https:${source.url}`
        : source.url;

      video.onloadedmetadata = finishUpdate;
      video.onerror = finishUpdate;
      video.load();

    } else {

      finishUpdate();

    }

  }

  updateDynamicThumbnail(media) {
    const thumbnail = this.thumbnails[this.dynamicGroupIndex];

    if (!thumbnail) return;

    /* Update thumbnail image */

    const image = thumbnail.querySelector('img');

    if (image && media.length) {
      image.src = media[0].preview;
      image.alt = media[0].alt || '';
    }

    /* Update dots */

    const dotsContainer = thumbnail.querySelector(
      '.product-custom-gallery__thumbnail-dots'
    );

    if (!dotsContainer) return;

    dotsContainer.innerHTML = '';

    if (media.length <= 1) {
      return;
    }

    media.forEach((item, index) => {
      const dot = document.createElement('span');

      dot.className = 'product-custom-gallery__thumbnail-dot';

      if (index === 0) {
        dot.classList.add('is-active');
      }

      dotsContainer.appendChild(dot);
    });
  }

  preloadAdjacentImages() {

    const total = this.gallery.slides.length;

    if (!total) return;

    [-1, 0, 1].forEach(offset => {

      let index = this.currentIndex + offset;

      if (this.useInfiniteLoop) {
        index = (index + total) % total;
      }

      if (index < 0 || index >= total) return;

      const slide = this.gallery.slides[index];

      if (!slide) return;

      // For a video the visible artwork is its poster, so that is what needs
      // warming — this used to skip videos entirely, which is why swiping
      // onto one showed an empty square.
      const url = slide.type === 'image'
        ? slide.url
        : (slide.previewLarge || slide.preview);

      if (!url || this.preloadedImages.has(url)) return;

      this.preloadedImages.add(url);

      const img = new Image();

      // Match the slide's own candidate selection, otherwise this warms the
      // full-width file while the slide fetches a smaller one — two downloads.
      if (slide.type === 'image' && slide.srcset) {
        img.sizes = '(min-width: 750px) 50vw, 100vw';
        img.srcset = slide.srcset;
      }

      img.src = url;

    });

    this.warmAdjacentVideos();

  }

  // The slides either side of the current one are the ones about to be seen,
  // so they skip the idle queue — a fast swiper outruns it. These also get
  // preload="metadata" so play() has the header already and can go straight
  // to fetching frames; everything further out stays at preload="none".
  warmAdjacentVideos() {
    const children = [...this.track.children];

    if (!children.length) return;

    const activeDomIndex = this.useInfiniteLoop && this.gallery.slides.length > 1
      ? this.currentIndex + 1
      : this.currentIndex;

    [-1, 0, 1].forEach(offset => {
      const child = children[activeDomIndex + offset];
      const video = child && child.querySelector('video');

      if (!video) return;

      const posterLarge = video.dataset.posterLarge;

      if (posterLarge && video.poster !== posterLarge) {
        video.poster = posterLarge;
      }

      if (video.preload === 'none') video.preload = 'metadata';
    });
  }

  updateUI() {
    this.updateTrackPosition();
    this.updateActiveSlide();
    this.updateActiveThumbnail();
    this.renderDots();
    this.updateArrowState();
    this.preloadAdjacentImages();
    this.playCurrentVideo();
  }

  render() {
    if (!this.gallery.slides.length) return;

    this.renderTrack();
    this.updateUI();
    this.removeLcpPlaceholder();
    this.scheduleVideoWarmup();
  }

  // What a video slide actually shows before it plays is its poster, so that
  // is what has to be ready — warming the video file itself buys nothing
  // visually. Once the page has loaded, pull every poster at display size.
  // These are ordinary images and small; the video files stay deferred.
  scheduleVideoWarmup() {
    clearTimeout(this.videoWarmupTimer);

    if (document.readyState !== 'complete') {
      if (!this.videoWarmupBound) {
        this.videoWarmupBound = true;
        window.addEventListener(
          'load',
          () => this.scheduleVideoWarmup(),
          { once: true }
        );
      }
      return;
    }

    this.videoWarmupTimer = setTimeout(() => {
      const warm = () => {
        this.track.querySelectorAll('video').forEach(video => {
          const posterLarge = video.dataset.posterLarge;

          if (!posterLarge || video.poster === posterLarge) return;

          // Fetch it before swapping the attribute, so the slide never
          // flickers through an empty frame mid-upgrade.
          const img = new Image();
          img.onload = () => { video.poster = posterLarge; };
          img.src = posterLarge;
        });
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(warm, { timeout: 2000 });
      } else {
        warm();
      }
    }, this.VIDEO_WARMUP_DELAY);
  }

  // The server-rendered first slide has done its job once the real track
  // exists. Both reference the same image, so removing it is not visible.
  removeLcpPlaceholder() {
    const placeholder = this.container.querySelector(
      '.product-custom-gallery__lcp'
    );

    if (placeholder) placeholder.remove();
  }

  // Shopify returns sources ordered [480, 1080, 720, m3u8], so a plain
  // find(height >= 720) always landed on 1080p — needless on a phone showing
  // a square video in a ~390px column. Pick the smallest rung that clears the
  // target for this viewport instead.
  pickVideoSource(media) {
    const sources = media.sources || [];
    const mp4s = sources
      .filter(source => source.format === 'mp4')
      .sort((a, b) => a.height - b.height);

    if (!mp4s.length) return sources[0];

    const isSmallViewport = window.matchMedia('(max-width: 749px)').matches;
    const targetHeight = isSmallViewport ? 720 : 1080;

    return (
      mp4s.find(source => source.height >= targetHeight) ||
      mp4s[mp4s.length - 1]
    );
  }

  renderTrack() {

    this.track.innerHTML = '';

    let slides = [...this.gallery.slides];

    if (this.useInfiniteLoop && slides.length > 1) {
        slides = [
        slides[slides.length - 1], // Clone last
        ...slides,
        slides[0] // Clone first
        ];
    }

    // Only the slide that is actually on screen is worth fetching up front.
    // Everything else is lazy; preloadAdjacentImages() warms the neighbours.
    const activeDomIndex = this.useInfiniteLoop && slides.length > 1
        ? this.currentIndex + 1
        : this.currentIndex;

    slides.forEach((media, domIndex) => {

        const slide = document.createElement('div');
        slide.className = 'product-custom-gallery__slide';

        const isActive = domIndex === activeDomIndex;

        if (media.type === 'video') {

        const source = this.pickVideoSource(media);

        if (source) {

            const videoUrl = source.url.startsWith('//')
            ? `https:${source.url}`
            : source.url;

            const video = document.createElement('video');

            video.className = 'product-custom-gallery__media';
            video.src = videoUrl;
            // Posters load even under preload="none", so off-screen slides
            // start on the small one. scheduleVideoWarmup() upgrades them to
            // this once the page has finished loading.
            video.dataset.posterLarge = media.previewLarge || media.preview;
            video.poster = isActive
                ? (media.previewLarge || media.preview)
                : media.preview;
            video.controls = false;
            video.playsInline = true;
            video.muted = true;
            video.loop = this.videoLoop;
            // Nothing is fetched until playCurrentVideo() calls play() on the
            // active slide, so off-screen videos cost no requests.
            video.preload = 'none';
            video.disablePictureInPicture = true;

            slide.appendChild(video);

        } else {

            // Fallback if no playable source exists
            slide.innerHTML = `
            <img
                class="product-custom-gallery__media"
                src="${isActive ? (media.previewLarge || media.preview) : media.preview}"
                alt="${media.alt || ''}"
                loading="${isActive ? 'eager' : 'lazy'}"
                decoding="async"
                draggable="false"
            >
            `;

        }

        } else {

        slide.innerHTML = `
            <img
            class="product-custom-gallery__media"
            src="${media.url}"
            ${media.srcset ? `srcset="${media.srcset}"` : ''}
            sizes="(min-width: 750px) 50vw, 100vw"
            alt="${media.alt || ''}"
            loading="${isActive ? 'eager' : 'lazy'}"
            ${isActive ? 'fetchpriority="high"' : ''}
            decoding="async"
            draggable="false"
            >
            `;

        }

        this.track.appendChild(slide);

    });

    this.trackIndex = this.useInfiniteLoop
        ? this.currentIndex + 1
        : this.currentIndex;

    requestAnimationFrame(() => {
        this.updateTrackPosition(false);
        this.updateActiveSlide();
        this.playCurrentVideo();
    });

  }

  updateActiveSlide() {

    const slides = this.track.querySelectorAll(
        '.product-custom-gallery__slide'
    );

    slides.forEach(slide => {
        slide.classList.remove('is-active');
    });

    if (slides[this.trackIndex]) {
        slides[this.trackIndex].classList.add('is-active');
    }

  }

  playCurrentVideo() {

    const slides = this.track.querySelectorAll(
        '.product-custom-gallery__slide'
    );

    slides.forEach(slide => {

        const video = slide.querySelector('video');

        if (!video) return;

        if (slide.classList.contains('is-active')) {

            video.muted = true;

            // Slides ship with preload="none"; opt the active one in so it
            // buffers ahead rather than only on the play() call.
            if (video.preload !== 'auto') video.preload = 'auto';

            video.play().catch(() => {});

        } else {

            video.pause();
            video.currentTime = 0;

        }

    });

  }

  pauseAllVideos() {

    this.track.querySelectorAll('video').forEach(video => {
        video.pause();
        video.currentTime = 0;
    });

  }

  updateTrackPosition(animated = true) {

    if (!this.track) return;

    this.track.style.transition = animated
      ? this.TRANSITION
      : 'none';

    this.track.style.transform =
      `translate3d(-${this.trackIndex * 100}%,0,0)`;
  }

  renderDots() {
    if (!this.dotsContainer) return;

    const currentSlide = this.getCurrentSlide();
    if (!currentSlide) return;

    const currentGroup = this.gallery.groups.find(
        group => group.groupIndex === currentSlide.groupIndex
    );

    if (!currentGroup) return;

    /* -------------------------
    * Main image dots
    * ------------------------- */

    this.dotsContainer.innerHTML = '';

    currentGroup.media.forEach((media, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'product-custom-gallery__dot';

        if (index === currentSlide.mediaIndex) {
        dot.classList.add('is-active');
        }

        dot.addEventListener('click', () => {
        this.goToMedia(currentSlide.groupIndex, index);
        });

        this.dotsContainer.appendChild(dot);
    });

    /* -------------------------
    * Thumbnail dots
    * ------------------------- */

    this.thumbnails.forEach((thumbnail, groupIndex) => {

      const dots = thumbnail.querySelectorAll(
        '.product-custom-gallery__thumbnail-dot'
      );

      dots.forEach(dot => dot.classList.remove('is-active'));

      if (groupIndex !== currentSlide.groupIndex) {
        return;
      }

      if (dots[currentSlide.mediaIndex]) {
        dots[currentSlide.mediaIndex].classList.add('is-active');
      }

    });

  }

  setCurrentIndex(index) {
    this.currentIndex = index;
    this.trackIndex = this.useInfiniteLoop
      ? index + 1
      : index;
  }

  getCurrentSlide() {
    return this.gallery.slides[this.currentIndex];
  }

  goToMedia(groupIndex, mediaIndex) {

    const slideIndex = this.gallery.slides.findIndex(
      slide =>
        slide.groupIndex === groupIndex &&
        slide.mediaIndex === mediaIndex
    );

    if (slideIndex === -1) return;

    this.setCurrentIndex(slideIndex);

    this.updateUI();

  }

  next() {

    if (this.isAnimating) return;

    this.pauseAllVideos();

    this.isAnimating = true;

    if (this.currentIndex === this.gallery.slides.length - 1) {

      // UI should immediately consider the first slide active
      this.currentIndex = 0;

      // Animate to the cloned first slide
      this.trackIndex++;

    } else {

      this.currentIndex++;
      this.trackIndex++;

    }

    this.updateUI();

  }

  previous() {

    if (this.isAnimating) return;

    this.pauseAllVideos();

    this.isAnimating = true;

    if (this.currentIndex === 0) {

      // UI should immediately consider the last slide active
      this.currentIndex = this.gallery.slides.length - 1;

      // Animate to the cloned last slide
      this.trackIndex--;

    } else {

      this.currentIndex--;
      this.trackIndex--;

    }

    this.updateUI();

  }

  goToGroup(groupIndex) {
    const slideIndex = this.gallery.slides.findIndex(
      (slide) => slide.groupIndex === groupIndex
    );

    if (slideIndex === -1) return;

    this.setCurrentIndex(slideIndex);
    this.updateUI();
  }

  scrollActiveThumbnailIntoView(smooth = true) {

    const currentSlide = this.getCurrentSlide();
    if (!currentSlide) return;

    const activeThumbnail = this.thumbnails[currentSlide.groupIndex];
    if (!activeThumbnail) return;

    const container = activeThumbnail.parentElement;

    const containerLeft = container.scrollLeft;
    const containerRight = containerLeft + container.clientWidth;

    const thumbLeft = activeThumbnail.offsetLeft;
    const thumbRight = thumbLeft + activeThumbnail.offsetWidth;

    if (thumbLeft >= containerLeft && thumbRight <= containerRight) {
      return;
    }

    activeThumbnail.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      inline: 'center',
      block: 'nearest'
    });

  }

  updateActiveThumbnail() {
    this.thumbnails.forEach((thumb) => {
      thumb.classList.remove('is-active');
    });

    const currentSlide = this.getCurrentSlide();

    if (!currentSlide) return;

    const activeThumb = this.thumbnails[currentSlide.groupIndex];

    if (activeThumb) {
      activeThumb.classList.add('is-active');
    }

    this.scrollActiveThumbnailIntoView();//!this.isAnimating
  }

  updateArrowState() {

    if (this.useInfiniteLoop) {

      this.prevButton.disabled = false;
      this.nextButton.disabled = false;

      return;

    }

    this.prevButton.disabled = this.currentIndex === 0;

    this.nextButton.disabled =
        this.currentIndex === this.gallery.slides.length - 1;

  }

  removeDuplicateMedia(mediaList) {
    const seen = new Set();

    return mediaList.filter((media) => {
      if (seen.has(media.id)) {
        return false;
      }

      seen.add(media.id);
      return true;
    });
  }

  //Swipe functions
  initSwipe() {

    this.stage.addEventListener(
        'touchstart',
        this.onTouchStart.bind(this),
        { passive: true }
    );

    this.stage.addEventListener(
        'touchend',
        this.onTouchEnd.bind(this),
        { passive: true }
    );

  }

  onTouchStart(event) {

    const touch = event.changedTouches[0];

    this.swipe.startX = touch.clientX;
    this.swipe.startY = touch.clientY;

  }

  onTouchEnd(event) {

    const touch = event.changedTouches[0];

    const deltaX = touch.clientX - this.swipe.startX;
    const deltaY = touch.clientY - this.swipe.startY;

    // Ignore mostly vertical swipes
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return;
    }

    const threshold = 60;

    if (deltaX > threshold) {
        this.previous();
    } else if (deltaX < -threshold) {
        this.next();
    }

  }

  onPointerDown(event) {

    this.swipe.startX = event.clientX;
    this.swipe.startY = event.clientY;
    this.swipe.isDragging = true;

    event.currentTarget.setPointerCapture(event.pointerId);

  }

  onPointerMove(event) {
    if (!this.swipe.isDragging) return;

    const deltaX = event.clientX - this.swipe.startX;
    const deltaY = event.clientY - this.swipe.startY;

    // User is scrolling vertically
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
        this.swipe.isDragging = false;
    }
  }

  onPointerUp(event) {

    if (!this.swipe.isDragging) return;

    this.swipe.isDragging = false;

    event.currentTarget.releasePointerCapture(event.pointerId);

    const deltaX = event.clientX - this.swipe.startX;

    const threshold = 60;

    if (Math.abs(deltaX) < threshold) {
        return;
    }

    if (deltaX <= -threshold) {
        this.next();
    } else if (deltaX >= threshold) {
        this.previous();
    }

  }

}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-custom-gallery').forEach((gallery) => {
    new ProductCustomGallery(gallery);
  });
});
